import { currencies } from "../Utils/Lists";
import useCurrentCurrency from "../Utils/useCurrentCurrency";
import { useContent } from "contexts/contentContext/contentContext";

export interface PriceI {
  [key: string]: {
    [key: string]: number;
  };
}

interface PriceDisplayElemI {
  isYearly: boolean;
  prices: PriceI;
  tablePrice?: boolean;
  discount?: number;
  isVatVisible?: boolean;
}

const PriceDisplayElem = ({
  isYearly,
  prices,
  tablePrice,
  discount,
  isVatVisible = false,
}: PriceDisplayElemI) => {
  const { getBlackFridayTime, getTextByKey, getDirection } = useContent();
  const currentUserCurrency = useCurrentCurrency();

  if (!prices) {
    return null;
  }

  const priceNoPromo = (price: number) => {
    const monthsQuantity = 12;
    const monthPrice = isYearly ? Math.ceil(price / monthsQuantity) : price;
    return monthPrice;
  };

  const priceIncludesPromo = (price: number) => {
    const monthPrice = priceNoPromo(price);
    if (getBlackFridayTime() && isYearly) {
      const discountCoefficient = discount ? 1 - discount / 100 : 0.7;
      return Math.ceil(monthPrice * discountCoefficient);
    }
  };

  const priceNumber =
    prices[isYearly ? "Price_Yearly" : "Price_Monthly"][currentUserCurrency];

  const priceWithoutWat =
    prices[isYearly ? "Price_Yearly" : "Price_Monthly"][
      `${currentUserCurrency}_NetPrice`
    ];

  const isPromo = isYearly && getBlackFridayTime();

  return (
    <div className="price-display">
      {isPromo ? (
        <h3 className="current-price">
          <span className="currency-icon">
            {currencies[currentUserCurrency]}
          </span>
          {priceIncludesPromo(priceWithoutWat || priceNumber)}
        </h3>
      ) : null}
      <h3 className={`current-price ${isPromo ? " strikediag" : ""}`}>
        {isPromo && !tablePrice ? null : (
          <span className="currency-icon">
            {currencies[currentUserCurrency]}
          </span>
        )}
        {priceNoPromo(priceWithoutWat || priceNumber)}
      </h3>
      {priceWithoutWat && isVatVisible ? (
        <div className="price-display-vat" dir={getDirection()}>
          {isPromo && !tablePrice ? null : (
            <span>{currencies[currentUserCurrency]}</span>
          )}
          <span>
            <span>
              {isPromo
                ? priceIncludesPromo(priceNumber)
                : priceNoPromo(priceNumber)}
            </span>{" "}
            <span>{getTextByKey("including-vat")}</span>
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default PriceDisplayElem;
